import { twJoin, twMerge } from '@troon/tailwind-preset/merge';
import { splitProps } from 'solid-js';
import type { Ref } from '@solid-primitives/refs';
import type { ParentProps, JSX } from 'solid-js';

type Props = ParentProps<
	JSX.HTMLAttributes<HTMLDivElement> & {
		appearance?: 'primary' | 'secondary' | 'default' | 'contained';
		layout?: 'tight';
		ref?: Ref<HTMLDivElement>;
	}
>;

export function Section(props: Props) {
	const [, spread] = splitProps(props, ['appearance', 'layout']);
	return (
		<div
			{...spread}
			class={twMerge(
				twJoin(
					'flex flex-col',
					props.layout === 'tight' ? 'gap-4' : 'gap-8',
					props.appearance && props.appearance !== 'default' && 'py-16 md:py-24',
					props.appearance === 'primary' && 'bg-brand-700 text-white',
					props.appearance === 'secondary' && 'bg-neutral-100',
					props.appearance === 'contained' && 'rounded-lg border border-neutral bg-white p-4 md:p-8',
				),
				props.class,
			)}
		/>
	);
}
